import { render, staticRenderFns } from "./ContactPage.vue?vue&type=template&id=48f3e3f5&scoped=true&"
import script from "./ContactPage.vue?vue&type=script&lang=js&"
export * from "./ContactPage.vue?vue&type=script&lang=js&"
import style0 from "./ContactPage.vue?vue&type=style&index=0&id=48f3e3f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f3e3f5",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/contact_page.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fcontact%2FContactPage.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports